import { Booking } from '../../models/Booking'
import { User } from '../../models/User'
import Button from '../app/design/Button'
import Card from '../app/design/Card'
import Modal from '../app/design/Modal'
import { ContactAvatar } from '../contacts/ContactAvatar'
import { ProListTableCell } from '../dashboards/ProListTableCell'

type Props = {
    bookings: Booking[]
    onCancelBooking: (notifyClient: boolean) => void
    onClose: () => void
    isSaving?: boolean
}

export function CancelBookingModal({ bookings, onCancelBooking, onClose, isSaving }: Props) {
    return (
        <Modal
            isOpen={bookings.length > 0}
            onClose={onClose}
            footer={
                <div className="my-3 flex justify-end gap-4">
                    <Button
                        intent="secondary"
                        onClick={() => onCancelBooking(false)}
                        isLoading={isSaving}
                    >
                        Cancel booking
                    </Button>
                    <Button
                        intent="primary"
                        onClick={() => onCancelBooking(true)}
                        isLoading={isSaving}
                    >
                        Cancel booking & notify client
                    </Button>
                </div>
            }
            title={bookings.length > 1 ? 'Cancel these bookings?' : 'Cancel this booking?'}
        >
            <Card className="flex flex-col p-0">
                {bookings.map((b) => (
                    <div className="flex justify-between" key={b.id}>
                        <div className="flex">
                            <ContactAvatar
                                user={b.client ?? new User()}
                                showName
                                subtitle={b.date?.format('ddd, MMM D, YYYY h:mm A')}
                            />
                        </div>

                        <div className="flex gap-1">
                            <ProListTableCell
                                pros={b.jobs.map((j) => j.person).filter((p) => !!p) as User[]}
                                showLabel={false}
                                size="xs"
                            />
                        </div>
                    </div>
                ))}
            </Card>
        </Modal>
    )
}
